import React, { useState, useEffect } from "react";
import { Paginator } from "../../../layout/Paginator/Paginator";
import { Search } from "../../../layout/Table/Search";
import { TableComponent } from "../../clients/table/Table";
import { Messages } from "../../../../components/layout/Messages/Messages";
import { ACL, USER_STATUSES } from '../../../../config/constants';
import { RowsPerPage } from "../../../layout/Table/RowsPerPage";
import { store } from '../../../../store/store';
import { hideNotification } from '../../../../store/actions/notification';
import { ListToolbar } from '../../../layout/Workspace';

function OrganizationUsersTab(props) {
  const [sortDirection, setSortDirection] = useState(null);
  const [sortField, setSortField] = useState(null);
  const [searchText, setSearchText] = useState(null);
  const { organization, getOrganizationUsers, users, metaUsers, rowsPerPageUsers, setRowsPerPageUsers } = props;
  const normalizedUsers = Array.isArray(users) ? users.map(user => {
    if (!user?.email_verified_at && user?.status === USER_STATUSES.ACTIVE) {
      return { ...user, status: USER_STATUSES.INACTIVE };
    }

    return user;
  }) : users;

  useEffect(() => {
    if (organization && getOrganizationUsers) {
      getOrganizationUsers(organization.id, 1, sortField, sortDirection, searchText);
    }

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPageUsers]);

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField(appliedSortField);
    setSortDirection(newSortDirection);

    getOrganizationUsers(organization.id, metaUsers.current_page, appliedSortField, newSortDirection, searchText, true);
  }

  return (
    <section className="organization-detail-section">
      <div className="organization-detail-section__messages">
        <Messages />
      </div>
      <ListToolbar
        className="organization-detail-list-toolbar"
        search={ACL.CLIENT.USERS.SEARCH.hasAccess() ? (
          <Search
              search={(searchText) => {
                setSearchText(searchText);
                getOrganizationUsers(organization.id, 1, null, null, searchText, true);
              }}
              id="users"
          />
        ) : null}
      />
      <div className="organization-detail-table">
        <TableComponent
          applySort={(sortField) => applySort(sortField)}
          users={normalizedUsers}
          actionCallback={(useState) => {
            if (useState) {
              getOrganizationUsers(
                organization.id,
                metaUsers.current_page,
                sortField,
                sortDirection,
                searchText
              );
            }
            getOrganizationUsers(organization.id);
          }}
        />
      </div>
      <Paginator
        meta={metaUsers}
        settings={(
          <RowsPerPage
            changeRowsPerPage={(rowsPerPage) => {
              setRowsPerPageUsers(rowsPerPage);
            }}
            id="users"
          />
        )}
        changePage={(page) =>
          getOrganizationUsers(organization.id, page, sortField, sortDirection, searchText, true)
        }
      />
    </section>
  );
}

export { OrganizationUsersTab };
